import React, { useEffect, useState } from "react";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { Checkbox, Typography } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import Divider from "@material-ui/core/Divider";
import CustomSelect from "../../../../../Components/CustomSelect";
import CustomInput from "../../../../../Components/CustomInput";
import CustomMultiSelectAutoComplete from "../../../../../Components/CustomMultiSelectAutoComplete";
import DataService from "../../../../../Service";
import Icon from "@material-ui/core/Icon";
import RemoveCircleOutlinedIcon from "@material-ui/icons/RemoveCircleOutlined";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import Loader from "../../../../../Components/Loader";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Alert, AlertTitle } from "@material-ui/lab";
import Chip from "@material-ui/core/Chip";
import index from "../../../../../Components/index";
import { Card } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    display: "flex",
    // padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
    "& span:last-child": {
      fontSize: "16px",
      fontFamily: "Open Sans",
      color: "#303030",
    },
    "& svg": {
      width: "1.5em",
      height: "1.5em",
    },
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 200,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  bottomBar: {
    boxShadow: "0px 0px 6px #232323",
    padding: "15px",
    textAlign: "center",
    margin: "0 -24px",
    marginTop: "10px",
    position: "fixed",
    bottom: "0",
    left: "0",
    right: "0",
    zIndex: 1075,
    backgroundColor: "#fff",
  },
  textAreaEmpty: {
    width: "100%",
    padding: "10px",
    border: "1px solid rgb(112, 112, 112)",
    borderRadius: "4px",
    marginTop: "-0.9rem",
    fontSize: "16px",
    fontFamily: "Open Sans",
  },
  commercialBilling: {
    marginTop: "2rem",
    "& h2": {
      marginTop: "0",
      marginBottom: "38px",
      fontFamily: "Open Sans"
    },
    "& p": {
      fontSize: "14px",
      fontFamily: "Open Sans",
      color: "#232323",
    },
  },
  summery: {
    // marginTop:'35px',
    marginBottom: "38px",
    "& h2": {
      marginBottom: "26px",
    },
  },
  clientBasics: {
    display: "contents",
    marginBottom: "50px",
    "& h2": {
      marginBottom: "20px",
    },
    "& span:last-child": {
      fontSize: "16px",
      color: "#303030",
      fontFamily: "Open Sans"
    },
  },
  invoice: {
    "& h2": {
      marginBottom: "24px",
    },
    "& span:last-child": {
      fontSize: "16px",
      color: "#303030",
      fontFamily: "Open Sans"
    },
  },
  invoiceOption: {
    "& h2": {
      marginBottom: "20px",
    },
    "& span:last-child": {
      fontSize: "16px",
      color: "#303030",
      fontFamily: "Open Sans"
    },
  },
  invoiceDetails: {
    "& h2": {
      marginBottom: "30px",
    }, "& span:last-child": {
      fontSize: "16px",
      color: "#303030",
      fontFamily: "Open Sans"
    }
  },
  expensePolicy: {
    "& h2": {
      marginBottom: "20px",
    },
    "& span:last-child": {
      fontSize: "14px",
      color: "#303030",
      fontFamily: "Open Sans"
    },
  },
  tableRoot: {
    "& table": {},
    boxShadow: "none",
    "& th, & td": {
      border: "none",
      "& strong": {
        fontSize: "16px",
      },
    },
    "& th": {
      color: "#fff",
    },
    "& th:first-child": {
      borderRadius: "5px 0 0 5px",
    },
    "& th:last-child": {
      borderRadius: "0 5px 5px 0",
    },
    "& thead": {
      backgroundColor: "#008080",
    },
    "& thead:first-child": {
      backgroundColor: "#3b86ff26",
      borderRadius: "5px",
      "& th": {
        color: "#3B86FF",
      },
    },
  },
  marginTableRoot: {
    backgroundColor: "#F8F8F8",
    borderRadius: "0",
    boxShadow: "none",
    "& th, & td": {
      border: "none",
    },
  },
  buttonCss: {
    textTransform: "capitalize",
    width: "128px",
    fontSize: "14px",
    fontFamily: "Open Sans",
    lineHeight: "16px",
    height: "35px",
    fontWeight: 900,
  },
  chipComponent: {
    "& div": {
      "& div > div": {
        borderRadius: "3px",
        "& svg": {
          color: "var(--unnamed-color-ffffff)",
        },
      },
    },
  },
}));

const CommercialsSupplier = (props) => {
  const {
    currentSelection,
    tabIndex,
    fetchApiFlag,
    setStepperData,
    setHeaderType,
    programForCoach,
  } = props;
  const classes = useStyles();
  const [commercialBillingData, setCommercialBillingData] = useState({});
  const [moduleSetups, setModuleSetups] = useState([]);
  const [checkBoxValue, setCheckBoxValue] = useState({});
  const [clientBillingScheduleArray, setClientBillingScheduleArray] = useState([
    {},
  ]);
  const [addOnBillingScheduleArray, setAddOnBillingScheduleArray] = useState([
    {},
  ]);
  const [selectDropDownValue, setSelectDropDownValue] = useState({});
  const [inputValue, setInputValue] = useState({});
  const [levelData, setLevelData] = useState([]);
  const [nextButtonLoading, setNextButtonLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [textAreaValue, setTextAreaValue] = useState({});
  const [emailData, setEmailData] = useState([]);

  const [addonData, setAddonData] = useState([]);
  const [elementPrice, setElementPrice] = useState(0);
  const [priceSummaryData, setPriceSummaryData] = useState({});

  const [clientInvoicingSelectedId, setClientInvoicingSelectedId] =
    useState(undefined);
  const [addOnsInvoicingSelectedId, setAddOnsInvoicingSelectedId] =
    useState(undefined);
  const [clientInvoicingCheck, setClientInvoicingCheck] = useState(null);
  const [addOnsInvoicingCheck, setAddOnsInvoicingCheck] = useState(null);
  const [expencePolicyArray, setExpencePolicyArray] = useState([
    {
      expense_available: false,
      expense_description: "",
      expense_frequency: "",
      other_frequency_value: "",
      policy_type: "travel",
    },
    {
      expense_available: false,
      expense_description: "",
      expense_frequency: "",
      other_frequency_value: "",
      policy_type: "travel_time",
    },
    {
      expense_available: false,
      expense_description: "",
      expense_frequency: "",
      other_frequency_value: "",
      policy_type: "third_party",
    },
    {
      expense_available: false,
      expense_description: "",
      expense_frequency: "",
      other_frequency_value: "",
      policy_type: "psychometric",
    },
    {
      expense_available: false,
      expense_description: "",
      expense_frequency: "",
      other_frequency_value: "",
      policy_type: "material",
    },
  ]);

  const frequencyMilestoneArray = [
    "After X session and end of assignment",
    "At the end of assignment",
    "Monthly",
    "After each session",
    "After 60% and after 40%",
    "Other",
  ];

  const clientInvoicingHandle = (id, event) => {
    const { name } = event?.target;
    setClientInvoicingSelectedId(id);
    setClientInvoicingCheck(name === clientInvoicingCheck ? undefined : name);
  };
  const addOnsInvoicingHandle = (id, event) => {
    const { name } = event?.target;
    setAddOnsInvoicingSelectedId(id);
    setAddOnsInvoicingCheck(name === addOnsInvoicingCheck ? undefined : name);
  };

  const rateCardType = ["Programme Price", "Session Rate", "Hourly Rate"];


  const clientInvoicingBasics = {
    PO: [{
      name: "po_number_for_each_assignment",
      value: "PO Number for each assignment",
    },
    // {
    //   name: "no_po_number",
    //   value: "No PO Number",
    // },
    {
      name: "po_number_for_multiple_assignment",
      value: "PO Number for multiple assignment",
    },
      // {
      //   name: "combination",
      //   value: "Multiple PO for multiple assignments",
      // },
    ],
    BILLING: [{
      name: "centralised_billing",
      value:
        "Centralised billing (Covers both single and multiple assignments)",
    },
    {
      name: "distributed_billing",
      value: "Distributed billing",
    }
    ],
    SUPPLIERS: [{
      name: "independent_coach_delivery",
      value: "Independent coach delivery",
    }, {
      name: "multiple_coach_suppliers",
      value: "Multiple coach suppliers",
    },
    ],
    ASSIGNMENTS: [{
      name: "single_assignment_adhoc",
      value: "Single assignment Ad hoc",
    }, {
      name: "multiple_assignments_block",
      value: "Multiple assignments block/starting at the same time",
    },
    ]
  }
  const clientInvoicingScheduleArray = [
    { id: 1, name: "tranche", value: "Tranche" },
    { id: 2, name: "each_session", value: "Each session" },
    { id: 3, name: "monthly", value: "Monthly" },
  ];

  const addOnsInvoicingScheduleArray = [
    { id: 1, name: "tranche", value: "Tranche" },
    { id: 2, name: "each_session", value: "Each session" },
    { id: 3, name: "monthly", value: "Monthly" },
  ];

  const programPriceType = [
    "Of program price",
    "Of program price after completion in hours",
    "Of program price after completion in sessions",
  ];

  const addOnsPriceType = [
    "Of add-on price",
    "Of add-on price after completion in hours",
    "Of add-on price after completion in sessions",
  ];

  const installmentType = ["In advance", "At midpoint", "On completion"];

  const clientInvoicingOptions = [
    "Client invoice",
    "Raise Proforma",
    "Drawdown from single Payment",
  ];

  let addOnsData = moduleSetups?.map((dd) => {
    return dd?.["module_name"];
  });

  let moduleFilteredData =
    moduleSetups &&
    moduleSetups.filter((e) => {
      return e.module_name === selectDropDownValue.add_ons;
    });

  useEffect(() => {
    moduleSetup();
    fetchLevels();
  }, []);

  useEffect(() => {
    fetchCommercialBilling();
  }, [fetchApiFlag]);

  const moduleSetup = () => {
    DataService.getDirectData(`/module_setups/listing_modules`)
      .then((res) => {
        if (res?.["success"]) {
          setModuleSetups(res?.["modules"]);
        }
      })
      .catch((error) => { });
  };

  const fetchLevels = () => {
    DataService.getDirectData("fetch_levels")
      .then((res) => {
        if (res?.success) {
          setLevelData(res);
        }
      })
      .catch();
  };

  const fetchCommercialBilling = () => {
    setLoading(true);
    DataService.getData(
      {
        master_template_id: currentSelection?.id,
        user_type: "supplier",
      },
      "fetch_commercial_billing"
    )
      .then((res) => {
        if (res?.success) {
          setLoading(false);
          setStepperData(res?.header_name || "Coaching commercials & billing");
          setHeaderType("commercials_and_billing");
          setCommercialBillingData(res?.data);
          setInputValue({
            name:
              res?.data?.invoicing_detail?.name || "Acuity Coaching Limited",
            invoice_address:
              res?.data?.invoicing_detail?.invoice_address ||
              "130 Helmshore Road, Holcombe Village, Bury, BL8 4PB, United Kingdom",
            invoice_narrative:
              res?.data?.invoicing_detail?.invoice_narrative || "",
            travel_expenses_description:
              res?.data?.expense_policy?.travel_expenses_description || "",
            travel_time_description:
              res?.data?.expense_policy?.travel_time_description || "",
            third_parties_description:
              res?.data?.expense_policy?.third_parties_description || "",
            psychometrics_description:
              res?.data?.expense_policy?.psychometrics_description || "",
            materials_description:
              res?.data?.expense_policy?.materials_description || "",
            num_of_sessions: res?.data?.num_of_sessions || "",
            num_of_hours: res?.data?.num_of_hours || "",
            for_acuity: res?.data?.margin_percent?.for_acuity || "",
            for_acuity_add_ons:
              res?.data?.margin_percent?.for_acuity_add_ons || "",
            for_coach: res?.data?.margin_percent?.for_coach || "",
            for_coach_add_ons:
              res?.data?.margin_percent?.for_coach_add_ons || "",
            client_num_of_session:
              res?.data?.primary_invoicing_schedule?.num_of_session || "",
            client_num_of_month:
              res?.data?.primary_invoicing_schedule?.num_of_month || "",
            addons_num_of_session:
              res?.data?.add_ons_invoicing_schedule?.num_of_session || "",
            addons_num_of_month:
              res?.data?.add_ons_invoicing_schedule?.num_of_month || "",
          });
          setEmailData(
            res?.data?.invoicing_detail?.email?.length
              ? res?.data?.invoicing_detail?.email
              : ["accounts@acuitycoaching.com"]
          );
          setTextAreaValue({
            payment_terms: res?.data?.invoicing_basic?.payment_terms || "",
          });
          setSelectDropDownValue({
            rate_card_type: res?.data?.rate_card_type || "",
            add_ons: res?.data?.add_ons || "",
            level: res?.data?.level || "",
            travel_expenses_frequency:
              res?.data?.expense_policy?.travel_expenses_frequency || "",
            travel_time_frequency:
              res?.data?.expense_policy?.travel_time_frequency || "",
            third_parties_frequency:
              res?.data?.expense_policy?.third_parties_frequency || "",
            psychometrics_frequency:
              res?.data?.expense_policy?.psychometrics_frequency || "",
            materials_frequency:
              res?.data?.expense_policy?.materials_frequency || "",
            num_of_tranche:
              res?.data?.primary_invoicing_schedule?.num_of_tranche || "",
            add_on_num_of_tranche:
              res?.data?.add_ons_invoicing_schedule?.num_of_tranche || "",
          });
          setCheckBoxValue({
            client_invoice: Boolean(
              res?.data?.invoicing_option?.client_invoice
            ),
            drawdone_from_single_payment: Boolean(
              res?.data?.invoicing_option?.drawdone_from_single_payment
            ),
            raise_proforma: Boolean(
              res?.data?.invoicing_option?.raise_proforma
            ),
            coach_can_claim_expenses_from_acuity: Boolean(
              res?.data?.expense_policy?.coach_can_claim_expenses_from_acuity
            ),
            expenses_reclaimable_from_client: Boolean(
              res?.data?.expense_policy?.expenses_reclaimable_from_client
            ),

            materials: Boolean(res?.data?.expense_policy?.materials),
            psychometrics: Boolean(res?.data?.expense_policy?.psychometrics),
            third_parties: Boolean(res?.data?.expense_policy?.third_parties),
            travel_expenses: Boolean(
              res?.data?.expense_policy?.travel_expenses
            ),
            travel_time: Boolean(res?.data?.expense_policy?.travel_time),

            po_number_for_each_assignment: Boolean(
              res?.data?.invoicing_basic?.po_number_for_each_assignment
            ),
            single_assignment_adhoc: Boolean(
              res?.data?.invoicing_basic?.single_assignment_adhoc
            ),
            po_number_for_multiple_assignment: Boolean(
              res?.data?.invoicing_basic?.po_number_for_multiple_assignment
            ),
            multiple_assignments_block: Boolean(
              res?.data?.invoicing_basic?.multiple_assignments_block
            ),
            no_po_number: Boolean(res?.data?.invoicing_basic?.no_po_number),
            centralised_billing: Boolean(
              res?.data?.invoicing_basic?.centralised_billing
            ),
            independent_coach_delivery: Boolean(
              res?.data?.invoicing_basic?.independent_coach_delivery
            ),
            distributed_billing: Boolean(
              res?.data?.invoicing_basic?.distributed_billing
            ),
            combination: Boolean(res?.data?.invoicing_basic?.combination),
            multiple_coach_suppliers: Boolean(
              res?.data?.invoicing_basic?.multiple_coach_suppliers
            ),
            coaching_request_form: Boolean(
              res?.data?.invoicing_basic?.coaching_request_form
            ),
            coaching_review_form: Boolean(
              res?.data?.invoicing_basic?.coaching_review_form
            ),
          });
          setClientInvoicingCheck(
            res?.data?.primary_invoicing_schedule?.invoicing_type || "tranche"
          );
          setAddOnsInvoicingCheck(
            res?.data?.add_ons_invoicing_schedule?.invoicing_type || "tranche"
          );

          setClientBillingScheduleArray(
            res?.data?.primary_invoicing_schedule?.billing_schedules || [{}]
          );
          setAddOnBillingScheduleArray(
            res?.data?.add_ons_invoicing_schedule?.billing_schedules || [{}]
          );

          setAddonData(
            res?.data?.price_summary
              .filter((item) => item.category !== "primary")
              ?.map((item) => ({ ...item, tempPrice: item.price }))
          );
          res?.data?.price_summary.forEach((item) => {
            if (item.category === "primary") {
              setInputValue({
                ...inputValue,
                for_acuity: item.acuity_margin_percent,
                for_coach: item.coach_margin_percent,
                num_of_hours: item.num_of_hours,
              });
              setPriceSummaryData({
                ...priceSummaryData,
                label: item.label,
                price: parseInt(item.price),
                rate_card_type: res?.data?.rate_card_type,
                hourly_rate: item.rate_card_type_price,
                num_of_hours: item.num_of_hours,
              });
            }
          });

          setExpencePolicyArray(
            res?.data?.expense_policy?.expense_policy_details.length > 0
              ? res?.data?.expense_policy?.expense_policy_details
              : expencePolicyArray
          );
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const addClientBillingSchedules = () => {
    const values = [...clientBillingScheduleArray];
    values.push({});
    setClientBillingScheduleArray(values);
  };

  const removeClientBillingSchedules = (index) => {
    const values = [...clientBillingScheduleArray];
    values.splice(index, 1);
    setClientBillingScheduleArray(values);
  };

  const addAddOnBillingSchedules = () => {
    const values = [...addOnBillingScheduleArray];
    values.push({});
    setAddOnBillingScheduleArray(values);
  };

  const removeAddOnBillingSchedules = (index) => {
    const values = [...addOnBillingScheduleArray];
    values.splice(index, 1);
    setAddOnBillingScheduleArray(values);
  };

  const handleAddOnBillingSchedules = (data, id, index) => {
    if (id) {
      // set input value
      const values = [...addOnBillingScheduleArray];
      values[index][id] = data;
      setAddOnBillingScheduleArray(values);
    } else {
      // set dropdown value
      const values = [...addOnBillingScheduleArray];
      values[index][data.id] = data.value;
      setAddOnBillingScheduleArray(values);
    }
  };
  const clientBillingPercentTotal = clientBillingScheduleArray?.reduce(
    (totalPer, data) => totalPer + parseInt(data.percentage, 10),
    0
  );
  const addOnsPercentTotal = addOnBillingScheduleArray?.reduce(
    (totalPerData, data) => totalPerData + parseInt(data.percentage, 10),
    0
  );

  const handleClientBillingSchedules = (data, id, index) => {
    if (id) {
      // set input value
      const values = [...clientBillingScheduleArray];
      values[index][id] = data;
      setClientBillingScheduleArray(values);
    } else {
      // set dropdown value
      const values = [...clientBillingScheduleArray];
      values[index][data.id] = data.value;
      setClientBillingScheduleArray(values);
    }
  };

  const handleSelectedValue = (event, index) => {
    setSelectDropDownValue({ ...selectDropDownValue, [event.id]: event.value });
  };

  const handleInputChange = (inputStateValue, inputId, index) => {
    setInputValue({ ...inputValue, [inputId]: inputStateValue });
  };

  const handleCheckboxValue = (event) => {
    if (event.target.name === "invoicing_type") {
      setCheckBoxValue({
        ...checkBoxValue,
        [event.target.name]: event.target.value,
      });
    } else {
      setCheckBoxValue({
        ...checkBoxValue,
        [event.target.name]: event.target.checked,
      });
    }
  };

  const handleChangeTextArea = (event) => {
    const { name, value } = event?.target;
    setTextAreaValue({ ...textAreaValue, [name]: value });
  };

  const handleExpencePolicyDetail = (data, name, index) => {
    const values = [...expencePolicyArray];
    values[index][name] = data;
    setExpencePolicyArray(values);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (clientBillingPercentTotal && clientBillingPercentTotal != 100) {
      return;
    }
    let clientBillingSchedules =
      clientBillingScheduleArray &&
      clientBillingScheduleArray.map((data, index) => {
        return {
          billing_schedule_id: data?.billing_schedule_id
            ? data.billing_schedule_id
            : "",
          percentage: data?.percentage
            ? `${data.percentage.replace("%", "")}%`
            : "",
          pgm_price_type: data?.pgm_price_type ? data.pgm_price_type : "",
          completion_time: data?.completion_time || "",
          installment_type: data?.installment_type ? data.installment_type : "",
        };
      });

    let addOnBillingSchedules =
      addOnBillingScheduleArray &&
      addOnBillingScheduleArray.map((data, index) => {
        return {
          billing_schedule_id: data?.billing_schedule_id
            ? data.billing_schedule_id
            : "",
          percentage: data?.percentage
            ? `${data.percentage.replace("%", "")}%`
            : "",
          pgm_price_type: data.pgm_price_type ? data.pgm_price_type : "",
          completion_time: data?.completion_time || "",
          installment_type: data?.installment_type ? data.installment_type : "",
        };
      });

    const numOfHours = () => {
      if (selectDropDownValue?.rate_card_type === "Hourly Rate") {
        return inputValue?.num_of_hours;
      } else if (selectDropDownValue?.rate_card_type === "Session Rate") {
        return inputValue?.num_of_sessions;
      } else {
        return "";
      }
    };

    const priceSummaryDataArray = [
      ...addonData.map((item) =>
        item?.id
          ? {
            id: item.id,
            category: "add_ons",
            label: item.label,
            price: item.price,
            acuity_margin_percent: item.acuity_margin_percent,
            coach_margin_percent: item.coach_margin_percent,
          }
          : {
            category: "add_ons",
            label: item.label,
            price: item.price,
            acuity_margin_percent: item.acuity_margin_percent,
            coach_margin_percent: item.coach_margin_percent,
          }
      ),
    ];

    let obj = {
      master_template_id: (currentSelection?.id).toString(),
      user_type: tabIndex === 1 && "supplier",
      level: selectDropDownValue.level ? selectDropDownValue.level : "",
      rate_card_type: selectDropDownValue?.rate_card_type,
      add_ons: addonData.map((item) => item.label),
      total_coaching_pgm_price: priceSummaryData?.price || "",
      specified_element_price: elementPrice,
      total_pgm_price: priceSummaryData?.price + elementPrice || "",
      price_summary: priceSummaryDataArray,
      margin_percent: {
        for_acuity: inputValue?.for_acuity,
        for_coach: inputValue?.for_coach,
        for_acuity_add_ons: inputValue?.for_acuity_add_ons,
        for_coach_add_ons: inputValue?.for_coach_add_ons,
      },
      invoicing_basic: {
        po_number_for_each_assignment: Boolean(
          checkBoxValue?.po_number_for_each_assignment
        ),
        po_number_for_multiple_assignment: Boolean(
          checkBoxValue?.po_number_for_multiple_assignment
        ),
        no_po_number: Boolean(checkBoxValue?.no_po_number),
        independent_coach_delivery: Boolean(
          checkBoxValue?.independent_coach_delivery
        ),
        combination: Boolean(checkBoxValue?.combination),
        single_assignment_adhoc: Boolean(
          checkBoxValue?.single_assignment_adhoc
        ),
        multiple_assignments_block: Boolean(
          checkBoxValue?.multiple_assignments_block
        ),
        centralised_billing: Boolean(checkBoxValue?.centralised_billing),
        distributed_billing: Boolean(checkBoxValue?.distributed_billing),
        multiple_coach_suppliers: Boolean(
          checkBoxValue?.multiple_coach_suppliers
        ),
        payment_terms: textAreaValue?.payment_terms,
      },
      primary_invoicing_schedule: {
        invoicing_type: clientInvoicingCheck,
        // "invoicing_type": checkBoxValue?.invoicing_type,
        num_of_tranche: selectDropDownValue?.num_of_tranche,
        billing_schedules: clientBillingSchedules,
        num_of_session: inputValue?.client_num_of_session,
        num_of_month: inputValue?.client_num_of_month,
      },
      add_ons_invoicing_schedule: {
        invoicing_type: addOnsInvoicingCheck,
        // "invoicing_type": checkBoxValue?.invoicing_type,
        num_of_tranche: selectDropDownValue?.add_on_num_of_tranche,
        billing_schedules: addOnBillingSchedules,
        num_of_session: inputValue?.addons_num_of_session,
        num_of_month: inputValue?.addons_num_of_month,
      },
      invoicing_option: {
        client_invoice: Boolean(checkBoxValue?.client_invoice),
        raise_proforma: Boolean(checkBoxValue?.raise_proforma),
        drawdone_from_single_payment: Boolean(
          checkBoxValue?.drawdone_from_single_payment
        ),
      },
      invoicing_detail: {
        name: inputValue?.name ? inputValue.name : "",
        invoice_address: inputValue?.invoice_address
          ? inputValue.invoice_address
          : "",
        email: emailData || [],
        invoice_narrative: inputValue?.invoice_narrative
          ? inputValue.invoice_narrative
          : "",
      },
      expense_policy: {
        expenses_reclaimable_from_client: Boolean(
          checkBoxValue?.expenses_reclaimable_from_client
        ),
        coach_can_claim_expenses_from_acuity: Boolean(
          checkBoxValue?.coach_can_claim_expenses_from_acuity
        ),
        expense_policy_details:
          expencePolicyArray.length > 0 ? expencePolicyArray : null,
      },
    };

    if (addOnsPercentTotal > 100 || clientBillingPercentTotal > 100) {
      return null;
    } else {
      if (
        commercialBillingData &&
        Object.keys(commercialBillingData).length === 0
      ) {
        setNextButtonLoading(true);
        DataService.createData(obj, "create_commercial_billing")
          .then((res) => {
            if (res?.success) {
              setNextButtonLoading(false);
              // getTemplateInfo();
              props.onNextClick();
            }
          })
          .catch((error) => {
            setNextButtonLoading(false);
          });
      } else {
        setNextButtonLoading(true);
        DataService.updateData(obj, "", "update_commercial_billing")
          .then((res) => {
            if (res?.success) {
              setNextButtonLoading(false);
              props.onNextClick();
            }
          })
          .catch(() => {
            setNextButtonLoading(false);
          });
      }
    }
  };
  return (
    <>
      <form spellCheck="false" onSubmit={handleSubmit}>
        <Container style={{ marginLeft: "-45px" }} maxWidth="xl">
          {loading && <Loader />}

          <Grid xs={12} container className={classes.commercialBilling}>
            <Grid
              container
              xs={12}
              style={{
                position: "relative",
              }}
            >
              <Grid
                xs={12}
                style={{
                  zIndex: "-1",
                  opacity: "0.2",
                }}
              >
                <Grid container spacing={5} className={classes.summery}>
                  <Grid item xs={8}>
                    <h2>Price summary</h2>
                    <TableContainer
                      component={Paper}
                      className={classes.tableRoot}
                    >
                      <Table
                        className={classes.table}
                        aria-label="simple table"
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell>Label</TableCell>
                            <TableCell>Rate card type</TableCell>
                            <TableCell>HRs for programme</TableCell>
                            <TableCell></TableCell>
                            {/* <TableCell>Session Rate</TableCell> */}
                            <TableCell colSpan={2}>
                              Price
                              {programForCoach
                                ? `(Percent - ${programForCoach}%)`
                                : ""}
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          <TableRow>
                            <TableCell>
                              {priceSummaryData?.label || "-"}
                            </TableCell>
                            <TableCell>
                              {priceSummaryData?.rate_card_type || "-"}
                            </TableCell>
                            <TableCell>
                              {priceSummaryData?.programme_hours || "-"}
                            </TableCell>
                            <TableCell></TableCell>
                            <TableCell>
                              {priceSummaryData?.add_ons_price?.toFixed(2) ||
                                "-"}
                            </TableCell>
                            {/* <TableCell><IconButton color="inherit"><EditIcon /></IconButton></TableCell> */}
                          </TableRow>
                          <TableRow>
                            <TableCell />
                            <TableCell />
                            <TableCell />
                            <TableCell>
                              <strong>Coaching program price</strong>
                            </TableCell>
                            <TableCell colSpan={2}>
                              <strong>
                                {priceSummaryData?.add_ons_price?.toFixed(2) ||
                                  "-"}
                              </strong>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                        <TableHead>
                          <TableRow>
                            <TableCell />
                            <TableCell />
                            <TableCell />
                            <TableCell />
                            <TableCell colSpan={2}>
                              <strong>
                                {priceSummaryData?.add_ons_price?.toFixed(2) ||
                                  "-"}
                              </strong>
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {addonData?.length ? (
                            addonData?.map((data, index) => {
                              return (
                                <>
                                  <TableRow>
                                    <TableCell colSpan={1}>
                                      {data ? data?.label : "-"}
                                    </TableCell>
                                    <TableCell />
                                    <TableCell />
                                    <TableCell />
                                    <TableCell>
                                      {data?.tempPrice || "-"}
                                    </TableCell>
                                  </TableRow>
                                </>
                              );
                            })
                          ) : (
                            <>
                              <TableRow>
                                <TableCell colSpan={1}>{"-"}</TableCell>
                                <TableCell />
                                <TableCell />
                                <TableCell>-</TableCell>
                                <TableCell>
                                  <Icon>-</Icon>
                                </TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell />
                                <TableCell />
                                <TableCell>
                                  <strong>-</strong>
                                </TableCell>
                                <TableCell>
                                  <strong>-</strong>
                                </TableCell>
                              </TableRow>
                            </>
                          )}
                          <TableRow>
                            <TableCell />
                            <TableCell />
                            <TableCell />
                            <TableCell>
                              <strong>Specified elements price</strong>
                            </TableCell>
                            <TableCell>
                              <strong>{elementPrice || "-"}</strong>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                        <TableHead>
                          <TableRow>
                            <TableCell />
                            <TableCell />
                            <TableCell />
                            <TableCell>
                              <strong>Total program price</strong>
                            </TableCell>
                            <TableCell colSpan={2}>
                              <strong>
                                {priceSummaryData?.price
                                  ? priceSummaryData?.price + elementPrice
                                  : elementPrice || "-"}
                              </strong>
                            </TableCell>
                          </TableRow>
                        </TableHead>
                      </Table>
                    </TableContainer>
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                conatiner
                xs={12}
                style={{
                  position: "absolute",
                  zIndex: "1",
                  margin: "auto",
                  textAlign: "left",
                  left: "400px",
                  top: "100px",
                }}
              >
                <Card
                  style={{
                    padding: "36px ",
                    fontSize: "20px",
                    width: "65%",
                    lineHeight: "1.5",
                    fontFamily: "Open Sans",

                  }}
                >
                  <strong>Note:</strong> This section requires client specific
                  rate card details, hence can be customised only in the "Create
                  Program" and "Create Assignment" flow
                </Card>
              </Grid>
            </Grid>

            <Grid className={classes.clientBasics}>
              <h2 style={{
                fontSize: "18px",
                fontFamily: "Open Sans"
              }}>Supplier invoicing basics</h2>
              <Grid container spacing={2} style={{ marginBottom: "20px" }}>
                <Grid item xs={4}>
                  <Grid container style={{
                    paddingLeft: "10px",
                    height: "35px",
                    backgroundColor: "#ef700080",
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "16px"
                  }}><Typography style={{ fontSize: "18px", fontWeight: "bold", textAlign: "left", padding: "5px", fontFamily: "Open Sans" }}>PO</Typography></Grid>

                  {clientInvoicingBasics.PO.map((data, index) => {
                    return (
                      <Grid item xs={12} spacing={2}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name={data?.name}
                              color="primary"
                              checked={Boolean(checkBoxValue[data?.name])}
                            />
                          }
                          onChange={handleCheckboxValue}
                          label={data.value}
                          className={classes.paper}
                        />
                      </Grid>
                    );
                  })}
                </Grid>
                <Grid item xs={4}>
                  <Grid container style={{
                    paddingLeft: "10px",
                    height: "35px",
                    backgroundColor: "#ef700080",
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "16px"
                  }}><Typography style={{ fontSize: "18px", fontWeight: "bold", textAlign: "left", padding: "5px", fontFamily: "Open Sans" }}>Supplier</Typography>
                  </Grid>
                  {clientInvoicingBasics.SUPPLIERS
                    .map((data, index) => {
                      return (
                        <Grid item xs={12} spacing={2}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                name={data?.name}
                                color="primary"
                                checked={Boolean(checkBoxValue[data?.name])}
                              />
                            }
                            onChange={handleCheckboxValue}
                            label={data.value}
                            className={classes.paper}
                          />
                        </Grid>
                      );
                    })}
                </Grid>
                <Grid item xs={4}>
                  <Grid container style={{
                    paddingLeft: "10px",
                    height: "35px",
                    backgroundColor: "#ef700080",
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "16px"
                  }}><Typography style={{ fontSize: "18px", fontWeight: "bold", textAlign: "left", padding: "5px", fontFamily: "Open Sans" }}>Assignments</Typography></Grid>
                  {clientInvoicingBasics.ASSIGNMENTS.map((data, index) => {
                    return (
                      <Grid item xs={12} spacing={2}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name={data?.name}
                              color="primary"
                              checked={Boolean(checkBoxValue[data?.name])}
                            />
                          }
                          onChange={handleCheckboxValue}
                          label={data.value}
                          className={classes.paper}
                        />
                      </Grid>
                    );
                  })}
                </Grid>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Typography
                    variant="subtitle1"
                    style={{ fontWeight: "bold", flex: 3 }}
                  >
                    Payment terms
                  </Typography>
                  <TextField
                    variant="outlined"
                    size="small"
                    inputProps={{ maxLength: 20 }}
                    name={`payment_terms`}
                    style={{ flex: 6, marginRight: 8 }}
                    onChange={handleChangeTextArea}
                    value={textAreaValue?.payment_terms}
                    placeholder="Type here"
                  />
                  <Typography variant="body1" style={{ flex: 3, marginLeft: 8 }}>
                    days
                  </Typography>
                </div>
              </Grid>
            </Grid>

            <Divider style={{ margin: "30px 0", width: "100%" }} />

            <Grid container className={classes.invoice}>
              <Grid item xs={6}>
                <h2 style={{
                  fontSize: "18px",
                  fontFamily: "Open Sans"
                }}>Supplier invoicing schedule</h2>
                <Grid container>
                  {clientInvoicingScheduleArray.map((data, index) => {
                    return (
                      <Grid item xs={3}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              id={data.id}
                              name={data.name}
                              value={data.value}
                              color="primary"
                              checked={clientInvoicingCheck === data.name}
                            />
                          }
                          onChange={(e) => clientInvoicingHandle(data?.id, e)}
                          label={data.value}
                          className={classes.paper}
                        />
                      </Grid>
                    );
                  })}
                </Grid>

                <Grid item xs={3}>
                  {clientInvoicingScheduleArray[0].name ===
                    clientInvoicingCheck ? (
                    <CustomSelect
                      id="num_of_tranche"
                      labelText="Select"
                      name="num_of_tranche"
                      targetId={"num_of_tranche"}
                      displayEmpty
                      variant="outlined"
                      itemArr={["1", "2", "3", "4", "5"]}
                      defaultValue={selectDropDownValue?.num_of_tranche}
                      parentcall={handleSelectedValue}
                      required={clientInvoicingSelectedId === 1}
                    />
                  ) : (
                    <></>
                  )}
                </Grid>
              </Grid>
              <Grid item xs={6}>
                <h2 style={{
                  fontSize: "18px",
                  fontFamily: "Open Sans"
                }}>Add-ons invoicing schedule</h2>
                <Grid container>
                  {addOnsInvoicingScheduleArray.map((data) => {
                    return (
                      <Grid item xs={3}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              id={data.id}
                              name={data.name}
                              value={data.value}
                              color="primary"
                              checked={data?.name === addOnsInvoicingCheck}
                            />
                          }
                          label={data.value}
                          onChange={(e) => addOnsInvoicingHandle(data?.id, e)}
                          className={classes.paper}
                        />
                      </Grid>
                    );
                  })}
                </Grid>
                <Grid item xs={3}>
                  {addOnsInvoicingScheduleArray[0].name ===
                    addOnsInvoicingCheck ? (
                    <CustomSelect
                      id="add_on_num_of_tranche"
                      labelText="Select"
                      name="num_of_tranche"
                      targetId={"num_of_tranche"}
                      displayEmpty
                      variant="outlined"
                      itemArr={["1", "2", "3", "4", "5"]}
                      defaultValue={selectDropDownValue?.add_on_num_of_tranche}
                      parentcall={handleSelectedValue}
                      required={addOnsInvoicingSelectedId === 1}
                    />
                  ) : (
                    <></>
                  )}
                </Grid>
              </Grid>
            </Grid>

            <Divider style={{ margin: "30px 0", width: "100%" }} />

            <Grid
              style={{ margin: "-20px -20px -4rem -20px" }}
              container
              spacing={5}
            >
              <Grid item xs={6}>
                <h2 style={{
                  fontSize: "18px",
                  fontFamily: "Open Sans"
                }}>Supplier billing schedule</h2>

                {clientInvoicingScheduleArray[0].name ===
                  clientInvoicingCheck &&
                  clientBillingPercentTotal &&
                  clientBillingPercentTotal != 100 ? (
                  <Alert severity="warning" style={{
                    fontSize: "16px",
                    fontFamily: "Open Sans"
                  }}>
                    Please enter percentage value to achieve 100%
                  </Alert>
                ) : (
                  <></>
                )}
                {!clientInvoicingCheck && (
                  <Alert severity="warning" style={{
                    fontSize: "16px",
                    fontFamily: "Open Sans"
                  }}>
                    Please enter any Supplier Invoicing Schedule.
                  </Alert>
                )}

                {clientInvoicingScheduleArray[1].name ===
                  clientInvoicingCheck ? (
                  <>
                    <Grid
                      container
                      spacing={5}
                      style={{
                        marginBottom: "30px",
                        marginLeft: "3px",
                      }}
                    >
                      <Grid>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "flex-start",
                          }}
                        >
                          <p>Invoice after completion of &nbsp;</p>
                          <CustomInput
                            inputProps={{ maxLength: 3 }}
                            maxLength={2}
                            name="session"
                            targetId={"client_num_of_session"}
                            id={"client_num_of_session"}
                            style={{ width: "50%" }}
                            type={"number"}
                            parentcall={handleInputChange}
                            value={inputValue?.client_num_of_session || ""}
                          />
                          <p style={{ marginLeft: "-6.5rem" }}>
                            &nbsp;of sessions
                          </p>
                        </div>
                      </Grid>
                    </Grid>
                  </>
                ) : clientInvoicingScheduleArray[2].name ===
                  clientInvoicingCheck ? (
                  <>
                    <Grid
                      container
                      spacing={5}
                      style={{ marginBottom: "30px", marginLeft: "3px" }}
                    >
                      <Grid>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "flex-start",
                          }}
                        >
                          <p>Invoice after completion of &nbsp;</p>
                          <CustomInput
                            inputProps={{ maxLength: 3 }}
                            maxLength={2}
                            name="monthly"
                            targetId={"client_num_of_month"}
                            id={"client_num_of_month"}
                            style={{ width: "50%" }}
                            type={"number"}
                            parentcall={handleInputChange}
                            value={inputValue?.client_num_of_month || ""}
                          />
                          <p style={{ marginLeft: "-6.5rem" }}>
                            &nbsp;of monthly
                          </p>
                        </div>
                      </Grid>
                    </Grid>
                  </>
                ) : clientInvoicingScheduleArray[0].name ===
                  clientInvoicingCheck ? (
                  clientBillingScheduleArray &&
                  clientBillingScheduleArray.map((data, index) => {
                    return (
                      <>
                        <Grid
                          container
                          spacing={3}
                          style={{ marginBottom: "30px", alignItems: "center" }}
                        >
                          <Grid item xs={2}>
                            {/*<TextField placeholder="Age" />*/}
                            <CustomInput
                              inputProps={{ maxLength: 3 }}
                              placeholder="percentage"
                              name="percentage"
                              targetId={"percentage"}
                              id={"percentage"}
                              value={data?.percentage?.replace("%", "")}
                              parentcall={(value, id) => {
                                handleClientBillingSchedules(value, id, index);
                              }}
                            />
                          </Grid>
                          <Grid item xs={5}>
                            <CustomSelect
                              id="pgm_price_type"
                              labelText="Program price type"
                              displayEmpty
                              variant="outlined"
                              itemArr={programPriceType}
                              name={"pgm_price_type"}
                              targetId={"pgm_price_type"}
                              defaultValue={data?.pgm_price_type}
                              parentcall={(event) => {
                                handleClientBillingSchedules(event, "", index);
                              }}
                              style={{
                                fontSize: "16px",
                                fontFamily: "Open Sans"
                              }}
                            />
                          </Grid>
                          <Grid item xs={4}>
                            <CustomSelect
                              id="installment_type"
                              labelText="Installment type"
                              displayEmpty
                              variant="outlined"
                              itemArr={installmentType}
                              name={"installment_type"}
                              targetId={"installment_type"}
                              defaultValue={data?.installment_type}
                              parentcall={(event) => {
                                handleClientBillingSchedules(event, "", index);
                              }} style={{
                                fontSize: "16px",
                                fontFamily: "Open Sans"
                              }}
                            />
                          </Grid>
                          <Grid item xs={1}>
                            {clientBillingScheduleArray.length - 1 !==
                              index && (
                                <RemoveCircleOutlinedIcon
                                  type={"submit"}
                                  fontSize="large"
                                  onClick={() =>
                                    removeClientBillingSchedules(index)
                                  }
                                  style={{
                                    cursor: "pointer",
                                    color: "red",
                                  }}
                                />
                              )}
                            {clientBillingScheduleArray.length - 1 ===
                              index && (
                                <AddCircleIcon
                                  type="submit"
                                  onClick={addClientBillingSchedules}
                                  fontSize="large"
                                  color="primary"
                                  style={{ cursor: "pointer" }}
                                />
                              )}
                          </Grid>
                          {data.pgm_price_type === programPriceType[1] && (
                            <Grid
                              container
                              spacing={5}
                              style={{
                                alignItems: "center",
                                marginBottom: "30px",
                              }}
                            >
                              <Grid item xs={2}></Grid>
                              <Grid item xs={5}>
                                <CustomInput
                                  inputProps={{ maxLength: 3 }}
                                  placeholder="Enter hours"
                                  name="hours"
                                  targetId={"hours"}
                                  id={"completion_time"}
                                  value={data?.completion_time}
                                  parentcall={(value, id) => {
                                    handleClientBillingSchedules(
                                      value,
                                      id,
                                      index
                                    );
                                  }} style={{
                                    fontSize: "16px",
                                    fontFamily: "Open Sans"
                                  }}
                                />
                              </Grid>
                            </Grid>
                          )}
                          {data.pgm_price_type === programPriceType[2] && (
                            <Grid
                              container
                              spacing={5}
                              style={{
                                alignItems: "center",
                                marginBottom: "30px",
                              }}
                            >
                              <Grid item xs={2}></Grid>
                              <Grid item xs={5}>
                                <CustomInput
                                  inputProps={{ maxLength: 3 }}
                                  placeholder="Enter sessions"
                                  name="session"
                                  targetId={"session"}
                                  id={"completion_time"}
                                  value={data?.completion_time}
                                  parentcall={(value, id) => {
                                    handleClientBillingSchedules(
                                      value,
                                      id,
                                      index
                                    );
                                  }} style={{
                                    fontSize: "16px",
                                    fontFamily: "Open Sans"
                                  }}
                                />
                              </Grid>
                            </Grid>
                          )}
                        </Grid>
                      </>
                    );
                  })
                ) : null}
              </Grid>
              <Grid item xs={6}>
                <h2 style={{
                  fontSize: "18px",
                  fontFamily: "Open Sans"
                }}>Add-ons billing schedule</h2>

                {addonData?.length &&
                  addOnsInvoicingScheduleArray[0].name === addOnsInvoicingCheck &&
                  addOnsPercentTotal != 100 ? (
                  <Alert severity="warning" style={{
                    fontSize: "16px",
                    fontFamily: "Open Sans"
                  }}>
                    Please enter percentage value to achieve 100%
                  </Alert>
                ) : (
                  <></>
                )}
                {!addOnsInvoicingCheck && (
                  <Alert severity="warning" style={{
                    fontSize: "16px",
                    fontFamily: "Open Sans"
                  }}>
                    Please enter any Add-ons invoicing schedule.
                  </Alert>
                )}
                {addOnsInvoicingScheduleArray[1].name ===
                  addOnsInvoicingCheck ? (
                  <>
                    <Grid
                      container
                      spacing={5}
                      style={{ marginBottom: "30px", marginLeft: "3px" }}
                    >
                      <Grid>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "flex-start",
                          }}
                        >
                          <p style={{
                            fontSize: "16px",
                            fontFamily: "Open Sans"
                          }}>Invoice after completion of &nbsp;</p>
                          <CustomInput
                            inputProps={{ maxLength: 3 }}
                            maxLength={2}
                            name="session"
                            targetId={"addons_num_of_session"}
                            id={"addons_num_of_session"}
                            style={{ width: "50%" }}
                            type={"number"}
                            parentcall={handleInputChange}
                            value={inputValue?.addons_num_of_session || ""}
                          />
                          <p style={{ marginLeft: "-6.5rem" }}>
                            &nbsp;of sessions
                          </p>
                        </div>
                      </Grid>
                    </Grid>
                  </>
                ) : addOnsInvoicingScheduleArray[2].name ===
                  addOnsInvoicingCheck ? (
                  <>
                    <Grid
                      container
                      spacing={5}
                      style={{ marginBottom: "30px", marginLeft: "3px" }}
                    >
                      <Grid>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "flex-start",
                          }}
                        >
                          <p style={{
                            fontSize: "16px",
                            fontFamily: "Open Sans"
                          }}>Invoice after completion of &nbsp;</p>
                          <CustomInput
                            inputProps={{ maxLength: 3 }}
                            maxLength={2}
                            name="monthly"
                            targetId={"addons_num_of_month"}
                            id={"addons_num_of_month"}
                            type={"number"}
                            parentcall={handleInputChange}
                            value={inputValue?.addons_num_of_month || ""} style={{
                              fontSize: "16px",
                              fontFamily: "Open Sans", width: "50%"
                            }}
                          />
                          <p style={{ marginLeft: "-6.5rem" }}>
                            &nbsp;of monthly
                          </p>
                        </div>
                      </Grid>
                    </Grid>
                  </>
                ) : addOnsInvoicingScheduleArray[0].name ===
                  addOnsInvoicingCheck ? (
                  addOnBillingScheduleArray &&
                  addOnBillingScheduleArray.map((data, index) => {
                    return (
                      <>
                        <Grid
                          container
                          spacing={3}
                          style={{ marginBottom: "30px", alignItems: "center" }}
                        >
                          <Grid item xs={2}>
                            {/*<TextField placeholder="Age" />*/}
                            <CustomInput
                              placeholder="percentage"
                              name="percentage"
                              targetId={"percentage"}
                              id={"percentage"}
                              value={data?.percentage?.replace("%", "")}
                              parentcall={(value, id) => {
                                handleAddOnBillingSchedules(value, id, index);
                              }}
                            />
                          </Grid>
                          <Grid item xs={5}>
                            <CustomSelect
                              id="pgm_price_type"
                              labelText="Program price type"
                              displayEmpty
                              variant="outlined"
                              itemArr={addOnsPriceType}
                              name={"pgm_price_type"}
                              targetId={"pgm_price_type"}
                              defaultValue={data?.pgm_price_type}
                              parentcall={(event) => {
                                handleAddOnBillingSchedules(event, "", index);
                              }} style={{
                                fontSize: "16px",
                                fontFamily: "Open Sans"
                              }}
                            />
                          </Grid>
                          <Grid item xs={4}>
                            <CustomSelect
                              id="installment_type"
                              labelText="Installment type"
                              displayEmpty
                              variant="outlined"
                              itemArr={installmentType}
                              name={"installment_type"}
                              targetId={"installment_type"}
                              defaultValue={data?.installment_type}
                              parentcall={(event) => {
                                handleAddOnBillingSchedules(event, "", index);
                              }} style={{
                                fontSize: "16px",
                                fontFamily: "Open Sans"
                              }}
                            />
                          </Grid>
                          <Grid item xs={1}>
                            {addOnBillingScheduleArray.length - 1 !== index && (
                              <RemoveCircleOutlinedIcon
                                type={"submit"}
                                fontSize="large"
                                onClick={() =>
                                  removeAddOnBillingSchedules(index)
                                }
                                style={{
                                  cursor: "pointer",
                                  color: "red",
                                }}
                              />
                            )}
                            {addOnBillingScheduleArray.length - 1 === index && (
                              <AddCircleIcon
                                type="submit"
                                onClick={addAddOnBillingSchedules}
                                fontSize="large"
                                color="primary"
                                style={{ cursor: "pointer" }}
                              />
                            )}
                          </Grid>
                          {data.pgm_price_type == addOnsPriceType[1] && (
                            <Grid
                              container
                              spacing={5}
                              style={{
                                alignItems: "center",
                                marginBottom: "30px",
                              }}
                            >
                              <Grid item xs={2}></Grid>
                              <Grid item xs={5}>
                                <CustomInput
                                  inputProps={{ maxLength: 3 }}
                                  placeholder="Enter hours"
                                  name="hours1"
                                  targetId={"completion_time"}
                                  id={"completion_time"}
                                  value={data?.completion_time}
                                  parentcall={(value, id) => {
                                    handleAddOnBillingSchedules(
                                      value,
                                      id,
                                      index
                                    );
                                  }} style={{
                                    fontSize: "16px",
                                    fontFamily: "Open Sans"
                                  }}
                                />
                              </Grid>
                            </Grid>
                          )}
                          {data.pgm_price_type == addOnsPriceType[2] && (
                            <Grid
                              container
                              spacing={5}
                              style={{
                                alignItems: "center",
                                marginBottom: "30px",
                              }}
                            >
                              <Grid item xs={2}></Grid>
                              <Grid item xs={5}>
                                <CustomInput
                                  inputProps={{ maxLength: 3 }}
                                  placeholder="Enter sessions"
                                  name="session1"
                                  targetId={"completion_time"}
                                  id={"completion_time"}
                                  value={data?.completion_time}
                                  parentcall={(value, id) => {
                                    handleAddOnBillingSchedules(
                                      value,
                                      id,
                                      index
                                    );
                                  }}
                                />
                              </Grid>
                            </Grid>
                          )}
                        </Grid>
                      </>
                    );
                  })
                ) : null}
              </Grid>
            </Grid>

            <Divider style={{ margin: "30px 0", width: "100%" }} />

            <Grid container className={classes.invoiceDetails}>
              <h2 style={{
                fontSize: "18px",
                fontFamily: "Open Sans"
              }}>Acuity invoicing details </h2>
              <Grid container>
                <Grid xs={1}>
                  <h3 style={{
                    fontSize: "16px",
                    fontFamily: "Open Sans"
                  }}>Name</h3>
                </Grid>
                <Grid xs={8} style={{ marginBottom: "2rem" }}>
                  <CustomInput
                    placeholder="Name"
                    name="name"
                    style={{
                      width: "70%", fontSize: "14px",
                      fontFamily: "Open Sans"
                    }}
                    targetId={"name"}
                    id={"name"}
                    value={inputValue?.name}
                    parentcall={handleInputChange}
                  />
                </Grid>
              </Grid>
              <Grid container>
                <Grid xs={1}>
                  <h3 style={{
                    fontSize: "16px",
                    fontFamily: "Open Sans"
                  }}>Invoice address</h3>
                </Grid>
                <Grid xs={8} style={{ marginBottom: "2rem" }}>
                  <CustomInput
                    name="invoice_address"
                    placeholder="Invoice address"
                    targetId={"invoice_address"}
                    id={"invoice_address"}
                    style={{
                      width: "70%", fontSize: "16px",
                      fontFamily: "Open Sans"
                    }}
                    parentcall={handleInputChange}
                    value={inputValue?.invoice_address}
                  />
                </Grid>
              </Grid>
              <Grid container>
                <Grid xs={1}>
                  <h3 style={{
                    fontSize: "16px",
                    fontFamily: "Open Sans"
                  }}>Email</h3>
                </Grid>
                <Grid xs={10} style={{ marginBottom: "2rem" }}>
                  <Autocomplete
                    id="email"
                    name={"email"}
                    multiple
                    freeSolo
                    disableCloseOnSelect
                    value={emailData || ""}
                    options={[]}
                    className={classes.chipComponent}
                    getOptionLabel={(option) => option}
                    getOptionSelected={(option, value) => value === option}
                    renderTags={(value, getTagProps) =>
                      value.map((option, index) => (
                        <Chip
                          // style={{backgroundColor:'transparent',borderRadius:'5px'}}
                          variant="outlined"
                          label={option}
                          {...getTagProps({ index })}
                        />
                      ))
                    }
                    style={{ width: "70%" }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Email"
                        variant="standard"
                        style={{
                          fontSize: "16px",
                          fontFamily: "Open Sans"
                        }}
                        fullWidth
                      />
                    )}
                    onChange={(_, selectedOptions) =>
                      setEmailData(selectedOptions)
                    }
                  />
                  <Typography
                    variant="caption"
                    display="block"
                    style={{ marginTop: 1, color: "gray" }}
                  >
                    Hit enter after typing email.
                  </Typography>
                </Grid>
              </Grid>
              <Grid container>
                <Grid xs={1}>
                  <h3 style={{
                    fontSize: "16px",
                    fontFamily: "Open Sans"
                  }}>Invoice narrative</h3>
                </Grid>
                <Grid xs={8}>
                  <CustomInput
                    name={"invoice_narrative"}
                    placeholder="Invoice narrative"
                    targetId={"invoice_narrative"}
                    id={"invoice_narrative"}
                    style={{
                      width: "70%", fontSize: "16px",
                      fontFamily: "Open Sans"
                    }}
                    parentcall={handleInputChange}
                    value={inputValue?.invoice_narrative}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Divider style={{ margin: "30px 0", width: "100%" }} />

            <Grid container xs={10} className={classes.expensePolicy}>
              <Grid item xs={12}>
                <h2 style={{
                  fontSize: "18px",
                  fontFamily: "Open Sans"
                }}>Supplier expense policy</h2>
              </Grid>
              <Grid xs={3}>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="expenses_reclaimable_from_client"
                      color="primary"
                      checked={Boolean(
                        checkBoxValue?.expenses_reclaimable_from_client
                      )}
                    />
                  }
                  onChange={handleCheckboxValue}
                  label="Expenses reclaimable from client"
                  className={classes.paper}
                />
              </Grid>
              <Grid xs={3} />
              <Grid xs={6}>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="coach_can_claim_expenses_from_acuity"
                      color="primary"
                      checked={Boolean(
                        checkBoxValue?.coach_can_claim_expenses_from_acuity
                      )}
                    />
                  }
                  onChange={handleCheckboxValue}
                  label="Coach can claim expenses from Acuity"
                  className={classes.paper}
                />
              </Grid>
              <Divider style={{ margin: "30px 0", width: "100%" }} />
            </Grid>

            {expencePolicyArray?.map((data, index) => {
              return (
                <Grid
                  container
                  xs={10}
                  style={{ marginBottom: "50px" }}
                  className={classes.expensePolicy}
                >
                  <>
                    <Grid xs={3}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            name={`expense_available`}
                            color="primary"
                            checked={Boolean(data?.expense_available)}
                          />
                        }
                        label={
                          data?.policy_type.charAt(0).toUpperCase() +
                          data?.policy_type.slice(1).replace("_", " ")
                        }
                        onChange={(e) => {
                          handleExpencePolicyDetail(
                            Boolean(e.target.checked),
                            e.target.name,
                            index
                          );
                        }}
                        className={classes.paper}
                      />
                      <TextField
                        disabled={
                          Boolean(!data?.expense_available) ? true : false
                        }
                        id="expense_description"
                        name="expense_description"
                        placeholder="Description"
                        multiline
                        rows={4}
                        value={data?.expense_description}
                        variant="outlined"
                        onChange={(e) => {
                          handleExpencePolicyDetail(
                            e.target.value || "",
                            e.target.name,
                            index
                          );
                        }}
                      />
                    </Grid>
                    <Grid xs={3} />
                    <Grid item xs={6}>
                      {index == 0 ? <h4>Frequency/milestones</h4> : null}
                      <CustomSelect
                        disabled={
                          Boolean(!data?.expense_available) ? true : false
                        }
                        id={`expense_frequency`}
                        labelText="Select"
                        displayEmpty
                        variant="outlined"
                        itemArr={frequencyMilestoneArray}
                        parentcall={(event) => {
                          handleExpencePolicyDetail(
                            event?.value,
                            event?.id,
                            index
                          );
                        }}
                        name={`expense_frequency`}
                        targetId={`expense_frequency`}
                        style={{ marginBottom: "1rem" }}
                        defaultValue={data?.expense_frequency}
                      />
                      {data?.expense_frequency == "Other" ? (
                        <TextField
                          disabled={
                            Boolean(!data?.expense_available) ? true : false
                          }
                          id="other_frequency_value"
                          name={"other_frequency_value"}
                          placeholder="Other"
                          multiline
                          rows={4}
                          value={data?.other_frequency_value}
                          variant="outlined"
                          style={{ marginBottom: "1rem", width: "100%" }}
                          onChange={(e) => {
                            handleExpencePolicyDetail(
                              e.target.value || "",
                              e.target.name,
                              index
                            );
                          }}
                        />
                      ) : null}
                    </Grid>
                  </>
                </Grid>
              );
            })}
            {/* </Grid> */}
          </Grid>
        </Container>
        <div className={classes.bottomBar}>
          <Button
            onClick={() => props.handleClose()}
            className={classes.buttonCss}
            style={{ marginRight: "10px" }}
            disabled={nextButtonLoading}
            type="submit"
            variant="contained"
          >
            Close
          </Button>
          <Button
            className={classes.buttonCss}
            type="submit"
            disabled={nextButtonLoading}
            variant="contained"
            color="secondary"
          >
            Next
          </Button>
        </div>
      </form>
    </>
  );
};
export default CommercialsSupplier;
